import { render, staticRenderFns } from "./ComplexList.vue?vue&type=template&id=0a09d084&"
import script from "./ComplexList.vue?vue&type=script&lang=js&"
export * from "./ComplexList.vue?vue&type=script&lang=js&"
import style0 from "./ComplexList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports